<template>
  <div>
    <ZklDistrbution />

    <!-- 各地区户口性质占比 -->
    <ZKLRegisrd />

    <div class="box_flex">
      <!-- 家庭户每户人员数量占比情况 -->
      <div class="lefet">
        <ZKLJiaTing />
      </div>
      
      <div class="rigth_end">
        <!-- 集体户每户人员数量占比情况 -->
        <ZKLjiTi />
      </div>
    </div>
  </div>
</template>

<script>
import ZklDistrbution from "./cnps/Zkl-distrbution.vue";
import ZKLRegisrd from "./cnps/Zkl-region.vue";
import ZKLJiaTing from "./cnps/Zkl-jiaTing.vue";
import ZKLjiTi from "./cnps/Zkl-jiTi.vue";
export default {
  components: {
    ZklDistrbution,
    ZKLRegisrd,
    ZKLJiaTing,
    ZKLjiTi,
  },
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {},
};
</script>

<style scoped lang="less">
.box_flex {
  display: flex;
  height: 450px;
  justify-content: space-between;
  margin: 16px 0;
  .lefet {
    width: 49.5%;
    height: 100%;
    // border: 1px solid;
  }
  .rigth_end {
    width: 49.5%;
    height: 100%;
    // border: 1px solid;
  }
}
</style>
